module.exports = __webpack_public_path__ + "media/img/uploads/logo-nawcwd-bb66c436840ef4102659b0e2eda88c95.png";